import { Card, Typography } from "antd";
import { useTranslation } from "react-i18next";

const ExportCard = ({ activeModel, children }) => {
  const { t } = useTranslation();
  const { Title } = Typography;

  const exportTitle = t("importTool:export.title", {
    model: t(`global:${activeModel}Plural`),
  });

  return (
    <Card title={exportTitle}>
      <Title level={5}>{t("importTool:export.filters")}</Title>
      {children}
    </Card>
  );
};

export default ExportCard;
